/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Share_Notifydescription2Inputs */

const en_coinvestments_share_notifydescription2 = /** @type {(inputs: Coinvestments_Share_Notifydescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send an email notification to contacts about this opportunity.`)
};

/**
* | output |
* | --- |
* | "Send an email notification to contacts about this opportunity." |
*
* @param {Coinvestments_Share_Notifydescription2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_share_notifydescription2 = /** @type {((inputs?: Coinvestments_Share_Notifydescription2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Share_Notifydescription2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_share_notifydescription2(inputs)
});
export { coinvestments_share_notifydescription2 as "coInvestments_share_notifyDescription" }